import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43428f42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "work-detail-container" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "py-2" }
const _hoisted_5 = { class: "author" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bar-code-area" }, [
  /*#__PURE__*/_createElementVNode("span", null, "扫一扫，手机预览"),
  /*#__PURE__*/_createElementVNode("canvas", { id: "barcode-container" })
], -1))
const _hoisted_7 = { class: "use-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.template)
      ? (_openBlock(), _createBlock(_component_a_row, {
          key: 0,
          type: "flex",
          justify: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { class: "cover-img" }, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  href: _ctx.template.coverImg
                }, [
                  _createElementVNode("img", {
                    id: "cover-img",
                    src: _ctx.template.coverImg,
                    alt: ""
                  }, null, 8, _hoisted_3)
                ], 8, _hoisted_2)
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 8 }, {
              default: _withCtx(() => [
                _createElementVNode("h2", null, _toDisplayString(_ctx.template.title), 1),
                _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.template.desc), 1),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_a_avatar, {
                    src: _ctx.template?.user?.picture
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" V ")
                    ]),
                    _: 1
                  }, 8, ["src"]),
                  _createTextVNode(" 该模版由 "),
                  _createElementVNode("b", null, _toDisplayString(_ctx.template.author), 1),
                  _createTextVNode(" 创作 ")
                ]),
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    size: "large",
                    onClick: _ctx.copyWork
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 使用模版 ")
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_a_button, {
                    size: "large",
                    onClick: _ctx.download
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 下载图片海报 ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}